export enum FulfillmentGroupColumnKey {
  SELECTED = "selected",
  ADDRESS_VERIFICATION = "address-verification",
  ASSIGNED_USER = "assigned-user",
  BATCH_ID = "batch-id",
  BIN = "bin",
  CUSTOMER = "customer",
  CUSTOMER_EMAIL = "customerEmail",
  CUSTOMER_PHONE = "customerPhone",
  CUSTOMER_ID = "customer-id",
  CUSTOMER_ORDER_COUNT = "customerOrderCount",
  CUSTOMER_PO = "customer-po",
  CUSTOMER_SHIPPING_SELECTION = "customer-shipping-selection",
  DELIVERY_DATE = "delivery-date",
  DELIVERY_METHOD = "delivery-method",
  DELIVERY_STATUS = "delivery-status",
  DESTINATION_COUNTRY = "destination-country",
  ELECTRONIC_COM_INVOICE = "electronic-com-invoice",
  ESTIMATED_DELIVERY_DATE = "estimated-delivery-date",
  FRAUD_RISK = "fraud-risk",
  FULFILLED_BY = "fulfilled-by",
  FULFILL_BY = "fulfillBy",
  FULFILLMENT_LOCATION = "fulfillment-location",
  INSURED = "insured",
  HOLD_NOTES = "hold-notes",
  INTERNAL_NOTES = "internal-notes",
  INVENTORY_PROJECTION = "inventory-projection",
  IS_PRINTED = "is-printed",
  ITEM_NAME = "item-name",
  ITEM_SKU = "item-sku",
  ITEM_BARCODE = "item-barcode",
  LOT_NUMBER = "lot-number",
  LOT_EXPIRATION_DATE = "lot-expiration-date",
  UNIT_COST = "unit-cost",
  TOTAL_COST = "total-cost",
  LABEL_PURCHASED_AT = "label-purchased-at",
  LINE_ITEM_CUSTOM_ATTRIBUTES = "line-item-custom-attributes",
  MARKETPLACE_INTERNAL_NOTE = "marketplace-internal-note",
  MARKETPLACE_NOTIFICATION_STATUS = "marketplace-notification-status",
  MISSING_BINS = "missingBins",
  AUTO_MERGE_DISABLED = "autoMergeDisabled",
  NOTE_FROM_BUYER = "note-from-buyer",
  NOTE_TO_BUYER = "note-to-buyer",
  ORDER_AGE = "order-age",
  ORDER_DATE = "order-date",
  ORDER_NAME = "order-name",
  ORDER_SOURCE = "order-source",
  ORDER_SUBTOTAL = "orderSubtotal",
  ORIGIN_STORE = "originStore",
  PACKING_SLIP_PRINTED_AT = "packing-slip-printed-at",
  PARCEL_SELECTION = "parcel-selection",
  PAYMENT_TYPE = "paymentType",
  POSTAL_CODE = "postal-code",
  PRODUCT_TAGS = "productTags",
  PRODUCT_VARIANT = "product-variant",
  QUANTITY = "quantity",
  RATE = "rate",
  RETURN_TRACKING_NUMBER = "returnTrackingNumber",
  RETURN_TRACKING_STATUS = "returnTrackingStatus",
  SHIPMENT_ADJUSTMENTS = "shipmentAdjustments",
  RECIPIENT = "recipient",
  REQUESTED_SERVICE = "requested-service",
  SALES_CHANNEL = "stores",
  SCAN_VERIFIED = "scan-verified",
  SERIAL_NUMBER = "serial-number",
  SHIPMENT_CREATED_AT = "shipment-created-at",
  SHIPMENT_TAGS = "tag",
  SHIPPED_DATE = "shipped-date",
  SHIPPING_MARGIN = "shippingMargin",
  SHIPPING_PAID = "shippingPaid",
  SHIPPING_SELECTED = "shippingSelected",
  SHIPPING_SELECTION = "shippingSelection",
  SHOPIFY_ORDER_TAGS = "shopify-order-tags",
  SLA_DELIVERY_PROMISE = "slaDeliveryPromise",
  STATE = "state",
  STATUS = "status",
  PICK_STATUS = "pickStatus",
  PICKED_AT = "pickedAt",
  ASSIGNED_TOTES = "assignedTotes",
  PICK_STARTED_ON = "pickStartedOn",
  MISSING_PICK_ITEMS = "missingPickItems",
  ASSIGNED_PICKER = "assignedPicker",
  PICKABILITY = "pickability",
  PICKABLE_BIN_COUNT = "pickableBinCount",
  WAREHOUSE_BINS = "warehouseBins",
  PRODUCT_BIN_ASSIGNMENT_DATE = "productBinAssignmentDate",
  PICK_SESSION_ID = "pick-session-id",
  STREET_ADDRESS = "street-address",
  TAX_TOTAL = "taxTotal",
  TOTAL = "total",
  TOTAL_SKU_COUNT = "total-sku-count",
  TRACKING_NUMBER = "trackingNumber",
  USPS_ZONE = "usps-zone",
  USED_WEIGHT_LEARNING = "used-weight-learning",
  USED_PARCEL_LEARNING = "used-parcel-learning",
  VENDORS = "vendors",
  WEIGHT = "weight",
  PICK_LIST_PRINTED = "is-pick-list-printed",
  PACKING_SLIP_PRINTED = "is-packing-slip-printed",
  LABEL_PRINTED = "is-label-printed",
  // Custom metadata columns (dynamically added)
  CUSTOM_STRING_1 = "customString1",
  CUSTOM_STRING_2 = "customString2",
  CUSTOM_STRING_3 = "customString3",
  CUSTOM_NUMBER_1 = "customNumber1",
  CUSTOM_NUMBER_2 = "customNumber2",
  CUSTOM_NUMBER_3 = "customNumber3",
  CUSTOM_DATE_1 = "customDate1",
  CUSTOM_DATE_2 = "customDate2",
  CUSTOM_DATE_3 = "customDate3",
  // Custom attributes columns (dynamically added)
  CUSTOM_ATTRIBUTE_STRING_1 = "customAttributeString1",
  CUSTOM_ATTRIBUTE_STRING_2 = "customAttributeString2",
  CUSTOM_ATTRIBUTE_STRING_3 = "customAttributeString3",
  CUSTOM_ATTRIBUTE_NUMBER_1 = "customAttributeNumber1",
  CUSTOM_ATTRIBUTE_NUMBER_2 = "customAttributeNumber2",
  CUSTOM_ATTRIBUTE_NUMBER_3 = "customAttributeNumber3",
  CUSTOM_ATTRIBUTE_DATE_1 = "customAttributeDate1",
  CUSTOM_ATTRIBUTE_DATE_2 = "customAttributeDate2",
  CUSTOM_ATTRIBUTE_DATE_3 = "customAttributeDate3",
  // Product custom metadata columns (dynamically added)
  PRODUCT_CUSTOM_STRING_1 = "productCustomString1",
  PRODUCT_CUSTOM_STRING_2 = "productCustomString2",
  PRODUCT_CUSTOM_STRING_3 = "productCustomString3",
  PRODUCT_CUSTOM_NUMBER_1 = "productCustomNumber1",
  PRODUCT_CUSTOM_NUMBER_2 = "productCustomNumber2",
  PRODUCT_CUSTOM_NUMBER_3 = "productCustomNumber3",
  PRODUCT_CUSTOM_DATE_1 = "productCustomDate1",
  PRODUCT_CUSTOM_DATE_2 = "productCustomDate2",
  PRODUCT_CUSTOM_DATE_3 = "productCustomDate3",
  // Variant custom metadata columns (dynamically added)
  VARIANT_CUSTOM_STRING_1 = "variantCustomString1",
  VARIANT_CUSTOM_STRING_2 = "variantCustomString2",
  VARIANT_CUSTOM_STRING_3 = "variantCustomString3",
  VARIANT_CUSTOM_NUMBER_1 = "variantCustomNumber1",
  VARIANT_CUSTOM_NUMBER_2 = "variantCustomNumber2",
  VARIANT_CUSTOM_NUMBER_3 = "variantCustomNumber3",
  VARIANT_CUSTOM_DATE_1 = "variantCustomDate1",
  VARIANT_CUSTOM_DATE_2 = "variantCustomDate2",
  VARIANT_CUSTOM_DATE_3 = "variantCustomDate3",
  ON_HAND_INVENTORY = "on-hand-inventory",
}
